// FYI: This file should be removed after home page refactor
// https://gousto.atlassian.net/browse/TG-6987
import React from 'react'

import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { useAuth } from 'routes/Menu/domains/auth'

import { getCtaProps } from '../homeUtils'
import { Hero } from './Hero'

export const HeroContainer = () => {
  const { isAuthenticated } = useAuth()
  const { ctaText, ctaUri } = getCtaProps(isAuthenticated)
  const isNewReducedPromoCodeEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_new_reduced_promocode_web_enabled',
  )

  return (
    <Hero
      isAuthenticated={isAuthenticated}
      ctaText={ctaText}
      ctaUri={ctaUri}
      isNewReducedPromoCodeEnabled={isNewReducedPromoCodeEnabled}
    />
  )
}
